import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cbasic() {

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
        updateDimensions()

        window.addEventListener('resize', updateDimensions)
        return () => window.removeEventListener('resize', updateDimensions)
    }, [])

    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
        if (width < 998) {
            setWindowpadding(2.5)
        } else {
            setWindowpadding(14)
        }
    }



    return (
        <div>
            <Sides />
            <Helmet>

                <title>First Program in C tutorial For Beginners</title>
                <meta name="description" content="First Program in C tutorial for beginners.Hello world program in c for beginners or first program in c,CodeExampler provides Free Online Tutorials for beginners" />
                <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,hello world program in c,first program in c,learn code in free,c programming tutorial for beginners,learn code in free online,c first program,first program in c,my first c program in english,c program to print first 10 natural numbers,c program to print first 10 even numbers
,hello world program in c,c program to print first n prime numbers,my first c program" />
                <link rel="canonical" href="https://www.codeexampler.com/c-first-program" />
            </Helmet>

            <div className='lg:pl-56'>

                <h1 className="m-4 mh1">Hello world program in C</h1><br />
                <div className="first">
                    <a href="/c-short-cut-keys">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
                    <a href="/c-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
                </div>


                <h2 className="mt-4 mh2">How to write C program for Beginners or hello world program in c:<br />
                </h2>
                <p className="mt-4 para">1, First program in c programming no blanks space used within a variable, constant, or keyword. <br />
                    2, All statements are entered in small case letters.<br />
                    3, All C statements end with a ;<br />
                    4, (;) means the statement terminate <br />
                    5, Main() – this is a collective name given to a set of statements. main() is a function, and Every function has a pair of parentheses ( ) Every function has a pair of parentheses ( ) <br />
                    6, Clrscr() – is used to clear screen<br />
                    7, and code finish by use (<span className="bold">return 0 ;</span>).<br />
                    8, This is the basics of c programming language<br />
                </p>

                <h2 className='headings'>Fundamental or First program for C Programming Syntax:</h2>
                <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
                    <pre style={{ maxHeight: "100vh" }}>
                        <code >
                            {"\n"}
                            <span className="qwerty-10"> main</span>
                            <span className="qwerty-3"> () </span>
                            {"\n"}
                            <span className="qwerty-3" > &#123; </span>
                            {"\n"}
                            <span className="qwerty-7">  Statement1</span>
                            <span className="qwerty-3">; </span>
                            {"\n"}
                            <span className="qwerty-4">  Statement2</span>
                            <span className="qwerty-3">; </span>
                            {"\n"}
                            <span className="qwerty-3" > &#125; </span>
                            {"\n"}{"\n"}
                        </code>
                    </pre>
                </div>




                <h2 className='headings'>Q-Write a hello world program in C example?</h2>
                <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
                    <pre style={{ maxHeight: "100vh" }}>
                        <code >
                            {"\n"}
                            <span className="qwerty-7">#include </span>
                            <span className="qwerty-3">&#60;</span>
                            <span className="qwerty-5">stdio.h</span>
                            <span className="qwerty-3">&#62; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-5">int </span>
                            <span className="qwerty-10">main</span>
                            <span className="qwerty-3"> ()</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-3" > &#123; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-2">//printf() is used to outputs the values on the screen</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-10">hello world program in C</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-10">   return</span>
                            <span className="qwerty-4"> 0</span>
                            <span className="qwerty-3">; </span>
                            {"\n"}
                            <span className="qwerty-3">&#125;</span>
                            {"\n"}{"\n"}
                        </code>
                    </pre>
                </div>
                <h4 className='headings'>Output :</h4>
                <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
                    <pre style={{ maxHeight: "100vh" }}>
                        <code >

                            {"\n"}
                            <span className="qwerty-10">hello world program in C</span>
                        </code>
                        {"\n"}{"\n"}
                    </pre>
                </div>


                <h2 className="mt-4 mh2"> Escape sequence character:
                </h2>
                <h3 className="m-4 mh3">\t – tab(gap b/w two characters)<br />
                    \n – newline<br />
                    \b – backspace<br />
                    \" – "<br />
                    \\ - \<br />
                    \0 – null used In a string<br />
                </h3>

                <p className="mt-4 para"><span className="bold" >Important</span>-each escape sequence Character occupied only one bite.
                </p>


                <h2 className='headings'>Q-Write a program to give sports name out for C programming example?</h2>
                <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
                    <pre style={{ maxHeight: "100vh" }}>
                        <code >
                            {"\n"}
                            <span className="qwerty-7">#include </span>
                            <span className="qwerty-3">&#60;</span>
                            <span className="qwerty-5">stdio.h</span>
                            <span className="qwerty-3">&#62; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-5">int </span>
                            <span className="qwerty-10">main</span>
                            <span className="qwerty-3"> ()</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-3" > &#123; </span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-10">sports</span>
                            <span className="qwerty-8">\n</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-10">1,football</span>
                            <span className="qwerty-8">\n</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-10">2.badminton</span>
                            <span className="qwerty-8">\n</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}{"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-10">3,tennis</span>
                            <span className="qwerty-8">\t</span>
                            <span className="qwerty-10">,cricket</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}
                            <span className="qwerty-7">   printf</span>
                            <span className="qwerty-3">("</span>
                            <span className="qwerty-8">\n</span>
                            <span className="qwerty-3">");</span>
                            {"\n"}
                            <span className="qwerty-10">   return</span>
                            <span className="qwerty-4"> 0</span>
                            <span className="qwerty-3">; </span>
                            {"\n"}
                            <span className="qwerty-3">&#125;</span>
                            {"\n"}{"\n"}
                        </code>
                    </pre>
                </div>
                <h4 className='headings'>Output :</h4>
                <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
                    <pre style={{ maxHeight: "100vh" }}>
                        <code >

                            {"\n"}
                            <span className="qwerty-4">sports</span>
                            {"\n"}
                            <span className="qwerty-10">1,football</span>
                            {"\n"}
                            <span className="qwerty-10">2,badminton</span>
                            {"\n"}
                            <span className="qwerty-10">3,tennis    4,cricket</span>
                            {"\n"}{"\n"}
                        </code>
                    </pre>
                </div>

                <h1 className="mt-5">  </h1>
                <div className="back">
                    <a href="/c-short-cut-keys"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
                    <a href="/c-input"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
                </div>
            </div></div>
    )

}
export default Cbasic;